import { useEffect, useState } from 'react';
import searchService from 'services/searchService';
import { useDebounce } from './useDebounce';
import { ProductSummary } from 'types/product';
import { SEARCH_DEBOUNCE_MS } from 'constants/catalog';

export const useProductSearch = (query: string, pageSize = 24) => {
  const debouncedQuery = useDebounce(query, SEARCH_DEBOUNCE_MS);
  const [results, setResults] = useState<ProductSummary[]>([]);
  const [loading, setLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(0);

  useEffect(() => {
    if (!debouncedQuery.trim()) {
      setResults([]);
      setTotalCount(0);
      return;
    }

    let active = true;
    setLoading(true);
    searchService
      .search(debouncedQuery, 1, pageSize)
      .then((data) => {
        if (active) {
          setResults(data.items);
          setTotalCount(data.totalCount);
        }
      })
      .catch(() => {
        if (active) {
          setResults([]);
          setTotalCount(0);
        }
      })
      .finally(() => {
        if (active) setLoading(false);
      });

    return () => {
      active = false;
    };
  }, [debouncedQuery, pageSize]);

  return { results, loading, totalCount, query: debouncedQuery };
};
